module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--bg-78e2f426baa23a89abe1b38fbde6d30f.jpg";